export const CENTERED_CONTENT_WIDTH = 1040;
export const HEADER_OFFSET = 56;
export const ANCHORED_BUTTON_OFFSET = '56px';
export const TRANSACTION_GRID = 'repeat(auto-fill, minmax(290px, 1fr))';
